export default {
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'History'
    },
    unique: [],
    sort: 'rating.gap',
    lang: {
        name: 'Rating History',
        category: ['User', 'Ratings'],
        description: 'Rating history of a game over time.',
        views: ['list', 'grid'],
        contexts: ['ratings'],
    },
    filters: []
}